import * as Yup from "yup";

export const createCircleValidation = Yup.object().shape({
  circleName: Yup.string().required("Circle name is required"),
  description: Yup.string().required("Description is required"),
  leader: Yup.string().optional().nullable(),
  membersCount: Yup.string()
    .oneOf(["<=5", ">5 <10", ">=10"], "Invalid member count")
    .optional()
    .nullable(),
  contributions: Yup.array()
    .of(
      Yup.object().shape({
        memberId: Yup.string().optional().nullable(),
        contributionAmount: Yup.number()
          .typeError("Contribution amount must be a number")
          .min(1, "Contribution amount must be at least 1")
          .optional()
          .nullable(),
        maxContributionTime: Yup.number()
          .typeError("Max contribution time must be a number")
          .min(1, "Max contribution time must be at least 1")
          .optional()
          .nullable(),
        contributionPeriod: Yup.string().optional().nullable(),
        // contributionDays: Yup.array()
        //   .of(Yup.string())
        //   .optional().nullable(),
        contributionDays: Yup.array()
          .of(
            Yup.string().oneOf(
              ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "Invalid day"
            )
          )
          .optional()
          .nullable(),
      })
    )
    .optional()
    .nullable(),

  payOuts: Yup.array()
    .of(
      Yup.object().shape({
        userId: Yup.string().optional().nullable(),
        payOutPeriod: Yup.string().optional().nullable(),
        payOutDay: Yup.array()
          .of(
            Yup.string().oneOf(
              ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "Invalid day"
            )
          )
          .optional()
          .nullable(),
      })
    )
    .optional()
    .nullable(),
});
